(function ($) {
  'use strict';

  /**
   * Site Popups
   * ---
   * - Uses MagnificPopup.js
   */


  /**
   * Inline Popups
   * - Uses the `data-mfp-src` attribute to assign popup container
   */

  var $inline_popup_button = $('.js-popup-button');
  var $inline_close_button = $('.js-popup-close');

  if ( $inline_popup_button.length ) {
    $inline_popup_button.magnificPopup({
      type: 'inline',
      midClick: true,
      showCloseBtn: false,
    });
  }

  $inline_close_button.on('click', function () {
    $.magnificPopup.close();
  });

})(jQuery);
